import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticleCards from './components/ArticleCards';
import ContentSections from './components/ContentSections';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleCards />
        <ContentSections />
      </main>
      <Footer />

      {/* Schema.org WebSite + Organization */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'WebSite',
                name: 'BaseTao Sheet',
                url: 'https://basetaosheet.team/',
                description: 'Independent educational resource for BaseTao Spreadsheet research, reviews, shipping guides, warehouse information, and practical tools.',
                potentialAction: {
                  '@type': 'SearchAction',
                  target: {
                    '@type': 'EntryPoint',
                    urlTemplate: 'https://basetaosheet.team/search?q={search_term_string}',
                  },
                  'query-input': 'required name=search_term_string',
                },
              },
              {
                '@type': 'Organization',
                name: 'BaseTao Sheet',
                url: 'https://basetaosheet.team/',
                logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png',
                description: 'An independent educational resource for BaseTao Spreadsheet research. Not affiliated with BaseTao.',
              },
            ],
          }),
        }}
      />
    </div>
  );
}